import { Directive } from '@angular/core';
import { HvlFormConstants } from '@hvlng/framework-core/form';
import { HrTranslateKey } from '../translate/hr-translate-key';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { LookupModel } from 'infrastructure-shared';
import { EnumHrmType } from '../../module/hrm-type/model/enum-hrm-type';

@Directive()
export abstract class HrBaseFormPartNew {
    public get formModeEnum(): typeof HvlFormConstants {
        return HvlFormConstants;
    }

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }

    public async setHrmTypeUuidAndReturn(
        form: UntypedFormGroup,
        hrmTypeList: Observable<Array<LookupModel>>,
    ): Promise<boolean> {
        const { disabled, hrmTypeUuid } = await this.isHrmTypeNone(hrmTypeList);
        if (disabled) {
            form.setVal('hrmTypeUuid', hrmTypeUuid);
        }
        return disabled;
    }

    private async isHrmTypeNone(hrmTypeList: Observable<LookupModel[]>): Promise<any> {
        return new Promise<{ disabled: boolean; hrmTypeUuid: string }>((resolve) => {
            hrmTypeList.subscribe((value) => {
                if (value.length === 1 && value[0].code === EnumHrmType.NONE) {
                    resolve({ disabled: true, hrmTypeUuid: value[0].uuid });
                } else {
                    resolve({ disabled: false, hrmTypeUuid: null });
                }
            });
        });
    }
}
